import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';


const JournelEntry = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const [itemOptions, setItemOptions] = useState([]); // Store available item options
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const [amount, setAmount] = useState('');
    const [itemsList, setItemsList] = useState([]); // Store added items

    const [modalData, setModalData] = useState(null); // Modal data
    const [tableData, setTableData] = useState([]); // Table data for display


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchmaxbillno(true);

    }, [isAuthenticated, companyId, token, logout]);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }

        try {
            // const response = await fetchData('JournelEntryAPI', `${companyId}/${branchId}`, token);
            const response = await fetchData('JournelEntryAPI', `/Master/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleInputChange = (newValue) => newValue;
    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState(true); // Default to Credit (true)
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNo: '',
        CustomerId: '',
        // PaymentType: '',
        Amount: 0,
        MAmount: 0,
        Remarks: '',
        createdBy: userId,
        isSubmit: false,
        IsType: true, // 1 for Credit, 2 for Debit
    });

    const submitData = async (e) => {
        e.preventDefault(); // Prevent form submission
        setIsLoading(true); // Set loading state

        if (!formData.Amount || formData.Amount <= 0) {
            setErrorMessage('Amount must be greater than 0!');
            setIsLoading(false);
            return;
        }

        if (itemsList.length === 0) {
            setErrorMessage('Please add at least one item to the list!');
            setIsLoading(false);
            return;
        }

        // Prepare Child Data (JournalEntryDetails) from itemsList
        const updatedChildFormData = itemsList.map((item, index) => ({
            JournalEntryId: 0, // Will be set after JournalEntry is created
            MasterId: item.MasterId || null, // Fetch from itemsList           
            Amount: item.Amount,
            CreatedBy: formData.CreatedBy,
            CreatedDate: new Date().toISOString(), // Current timestamp
            IsActive: true, // Default active
        }));


        // Combine Data for API
        const journelEntryVM = {
            JournalEntry: formData,
            JournalEntryDetails: updatedChildFormData,
        };

        try {
            // API Call
            const response = await postData('JournelEntryAPI', journelEntryVM, token);

            // Success Handling
            setSuccessMessage('Journal Entry Created Successfully!');
            setErrorMessage('');
            setFormData({
                ...formData,
                BillDate: '',
                BillNo: 0,
                CustomerId: '',
                PaymentType: '',
                Amount: 0,
                Remarks: '',
                IsType: null,
            });
            setItemsList([]); // Clear the items list
            setIsLoading(false);
            history.push('/JournelEntryIndex'); // Redirect to Receipt Index

            // Reset success message after timeout
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        } catch (error) {
            console.error('Journal Entry Creation Error:', error);

            // Detailed Error Logging
            if (error.response) {
                console.error('Response Data:', error.response.data);
                console.error('Response Status:', error.response.status);
            } else if (error.request) {
                console.error('No Response Received:', error.request);
            } else {
                console.error('Error Setting up Request:', error.message);
            }

            // Show Error Message
            setErrorMessage('Failed to create Journal Entry. Please try again.');
            setIsLoading(false);
        }
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);

    const fetchChildOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }

        try {
            // const response = await fetchData('JournelEntryAPI', `${companyId}/${branchId}`, token);
            const response = await fetchData('JournelEntryAPI', `/Master/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setchildOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };
    const handleChildInputChange = (newValue) => newValue;
    // Handle customer selection
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedChildOption ? selectedChildOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedChildOption) return;
    };


    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "IsType"
                ? value === "1"
                : name === "PaymentType"
                    ? Number(value) // Ensure PaymentType is stored as a number
                    : type === "checkbox"
                        ? checked
                        : value,
        }));


        let ispaymentType = true;

        if (name === "IsType") {
            ispaymentType = value === "1";
            setSelectedPaymentType(ispaymentType);
            fetchData('JournelEntryAPI', `/MaxBillno/${companyId}/${branchId}/${ispaymentType}`, token)
                .then((response) => response.response_data)
                .then((data) => {
                    const currentDate = new Date();
                    const year = currentDate.getFullYear();
                    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                    const day = String(currentDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;

                    setFormData(prevData => ({
                        ...prevData,
                        BillNumber: data.BillNumber,
                        //BillNumber: `${data.BillNumber}/${data.FinYear}`,
                        BillNo: data.BillNumber,
                        BillDate: formattedDate,
                        FinYear: data.FinYear,
                        BranchId: branchId,
                        CompanyId: companyId,
                    }));
                })
                .catch((error) => {
                    console.error('Error fetching Max Billno:', error);
                });
        } else {

        }
    };


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);



    const addItemToList = () => {
        if (!selectedChildOption || !formData.CAmount || formData.CAmount <= 0) {
            setErrorMessage('Please select a valid item and enter a valid amount!');
            return;
        }
        const newItem = {
            slNo: itemsList.length + 1,
            MasterName: selectedChildOption.label,
            MasterId: selectedChildOption.value,
            Amount: formData.CAmount,
        };

        const updateddetails = [...itemsList, newItem];
        setItemsList(updateddetails);
        setErrorMessage('');
        setSelectedChildOption(null);

        let amt = updateddetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const TaxRate = parseAndFix(formData.TaxRate);
        let taxAmount = 0;
        taxAmount = ((amt * TaxRate) / 100).toFixed(2);

        let netAmount = parseAndFix(amt) + parseAndFix(taxAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;

        setFormData((prev) => ({
            ...prev,
            CAmount: 0,
            Amount: amt,
            TaxAmount: parseFloat(taxAmount).toFixed(2),
            RoundOff: parseFloat(roundOff).toFixed(2),
            TotalAmount: parseFloat(grandTotal).toFixed(2),
        }));
    };

    // Function to delete an item from the list
    const handleDelete = (slNo) => {
        const updatedList = itemsList.filter((item) => item.slNo !== slNo);
        setItemsList(updatedList);
    };

    // Function to fetch MaxBillno

    const fetchmaxbillno = (Inputstring) => {
        // Use the parameter directly, no need to rely on formData here
        fetchData('JournelEntryAPI', `/MaxBillno/${companyId}/${branchId}/${Inputstring}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // Update formData with the fetched data
                setFormData((prevData) => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillNo: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno:', error);
            });
    };

    useEffect(() => {
        fetchmaxbillno(true);
    }, []);


    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setItemsList((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };

            // Update the item in the copied array
            updatedDetails[index] = currentItem;

            const totals = updatedDetails.reduce(
                (acc, item) => {
                    acc.Amount += parseAndFix(item.Amount);
                    return acc;
                },
                { Amount: 0 }
            );



            totalCalculation(
                totals.Amount,
            );

            return updatedDetails;
        });
    };
    const parseAndFix = (val) => parseFloat(val) || 0;
    const totalCalculation = (Amount) => {

        setFormData((prev) => ({
            ...prev,
            Amount: Amount,
        }));
    };

    useEffect(() => {
        let amt = itemsList.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const TaxRate = parseAndFix(formData.TaxRate);
        let taxAmount = 0;
        taxAmount = ((amt * TaxRate) / 100).toFixed(2);

        let netAmount = parseAndFix(amt) + parseAndFix(taxAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;

        setFormData((prev) => ({
            ...prev,
            Amount: amt,
            TaxAmount: parseFloat(taxAmount).toFixed(2),
            RoundOff: parseFloat(roundOff).toFixed(2),
            TotalAmount: parseFloat(grandTotal).toFixed(2),
        }));
    }, [itemsList, formData.TaxRate]);

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%', marginTop: '-0.55%' }}>

                <div className="flex flex-wrap justify-between items-center mb-4">
                    <h6
                        className="uppercase tracking-wide text-black font-serif flex-grow"
                        style={{
                            fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                            color: 'black',
                            marginTop: '10px',
                        }}
                    >
                        CREATE Journal Entry
                    </h6>
                    <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                        <div className='w-full mb-2 flex'>

                            <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="1"
                                    checked={formData.IsType === true}
                                    onChange={handleChange}
                                />
                                Debit
                            </label>
                            <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="0"
                                    checked={formData.IsType === false}
                                    onChange={handleChange}
                                />
                                Credit
                            </label>

                        </div>
                    </div>

                    <div className="flex mt-8 w-full sm:w-auto">

                        <Button
                            style={{
                                background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Save</b>}
                        </Button>

                        <Button
                            color="error"
                            component={Link}
                            to={{
                                pathname: "/JournelEntryIndex",
                                state: { from: "/JournelEntry" },
                            }}
                            onClick={() => {
                                localStorage.setItem('shouldReload', 'true');
                            }}
                            className="linkcolor"
                            style={{
                                background: 'linear-gradient(to right, #FFAAAA,#FFAAAA)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                        >
                            <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                        </Button>
                    </div>

                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className="w-full flex flex-wrap md:flex-row flex-col">
                {/* Left Section: Entry Fields */}
                <div
                    className="flex-1 p-4"
                    style={{
                        backgroundColor: '#f3f3f3',
                        borderRadius: '10px',
                        marginTop: '-10px',
                    }}
                >
                    <div className="mb-3">
                        <div className="flex flex-wrap gap-x-4">
                            <div className="flex-1 w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                    Master <span className="text-red-500">*</span>
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleCustomerSelect}
                                    value={selectedOption}
                                />
                            </div>
                            <div className="w-1/5  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="date"
                                    value={formatDateForInput(formData.BillDate)}
                                    name="BillDate"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                    name="BillNo"
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 mt-3">
                            <div className="flex-1  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                    Remarks
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={formData.Remarks}
                                    name="Remarks"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="w-1/4  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="amount">
                                    Amount
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline text-right"
                                    type="number"
                                    value={formData.Amount}
                                    name="Amount"
                                    onChange={handleChange}
                                    readOnly
                                />
                            </div>
                            <div className="w-1/6 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-black text-xs font-bold mb-2 flex items-center gap-x-2"
                                    htmlFor="gstPercentage"
                                >
                                    Tax %
                                </label>
                                <select
                                    className="shadow border rounded w-full py-2 px-3 text-black-700 leading-tight focus:shadow-outline"
                                    name="TaxRate"
                                    value={formData.TaxRate || 0}
                                    onChange={handleChange}
                                >
                                    <option value={0}>0</option>
                                    <option value={7}>7</option>
                                    <option value={19}>19</option>
                                </select>
                            </div>

                        </div>

                        <div className="flex flex-wrap items-center gap-x-4 mt-3">

                            <div className="w-2/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Tax Amount : <span style={{ color: 'red', fontSize: '14px' }}>{formData.TaxAmount}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    R.Off : <span style={{ color: 'red', fontSize: '14px' }}>{formData.RoundOff}</span>
                                </label>
                            </div>

                            <div className="w-2/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total : <span style={{ color: 'red', fontSize: '14px' }}>{formData.TotalAmount}</span>
                                </label>
                            </div>
                        </div>



                        <div className="w-full mb-2 flex" style={{ marginTop: '0.75%' }}>
                            <div className="w-4/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Master
                                    <span className="text-red-500">*</span>
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchChildOptions}
                                    onInputChange={handleChildInputChange}
                                    onChange={handleChildSelect}
                                    value={selectedChildOption}
                                />
                            </div>

                            <div className="w-1/3 mr-2" style={{ marginTop: '1.30%' }}>
                                <label
                                    className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                                    htmlFor="MinimumStock"
                                >
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                    type="number"
                                    value={formData.CAmount}
                                    onChange={handleChange}
                                    placeholder="Enter Amount"
                                    name="CAmount"
                                    step="0.01"  // Allow decimals
                                    style={{ textAlign: 'right' }}
                                    min={0}
                                />
                            </div>


                            {/* Add Button */}
                            <div className="w-2/5 mr-2" style={{ marginTop: '3.90%' }}>
                                <button className="px-4 py-2 rounded" onClick={addItemToList}
                                    style={{
                                        color: 'white',
                                        fontWeight: 'bolder',
                                        textTransform: 'none',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                        maxHeight: '35px',
                                        marginLeft: '6px',
                                        backgroundColor: '#D3F1DF'
                                    }}>
                                    <span style={{ marginTop: '2%', color: 'black' }}>+ ADD</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Section: Table */}
                <div className="flex-1 p-4">
                    <div className="rounded-lg shadow overflow-hidden" style={{ backgroundColor: '#EDDFE0', marginTop: '-1.95%' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ textAlign: 'center', fontWeight: 'bold', color: 'darkblue', padding: '4px' }}>
                                            SELECTED MASTER LIST
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ padding: '4px' }}>Sl.No</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Party</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Amount</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemsList.length > 0 ? (
                                        itemsList.map((raterelation, index) => (
                                            <TableRow key={index}>
                                                <TableCell style={{ padding: '3px' }}>{raterelation.slNo}</TableCell>
                                                <TableCell style={{ padding: '3px' }}>{raterelation.MasterName}</TableCell>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                                    <input
                                                        type="number"
                                                        value={raterelation.Amount}
                                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FFCF96', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`amount for master ${raterelation.Id}`}
                                                        name="Amount"
                                                        onChange={(e) => handleCalculation(e, index, 'Amount')}
                                                    />
                                                </td>
                                                <TableCell style={{ padding: '3px' }}>
                                                    <IconButton color="error" onClick={() => handleDelete(raterelation.slNo)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No Items Selected
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>



        </Fragment >
    );
};


export default JournelEntry;
